export type PrometheusPostgreSqlSelectFetchedStatsBackendApiProps = {
    created: number;
    pg_stat_database_tup_fetched: number;
};

export default class PrometheusPostgreSqlSelectFetchedStats {
    readonly created: number;
    readonly pgStatDatabaseTupFetched: number;

    constructor(props: PrometheusPostgreSqlSelectFetchedStatsBackendApiProps) {
        this.created = props.created;
        this.pgStatDatabaseTupFetched = props.pg_stat_database_tup_fetched;
    }
}
